module.exports = __webpack_public_path__ + "img/sgyl.b364f8fb.png";